const LIFETIME = 10; // 10.seconds
const SIMPLE_PREFIX = "simple_storage_locker";

const getSimpleKey = (key) => `${SIMPLE_PREFIX}:${key}`;
const isLocked = (key) => !!window.storage.getItem(key);
const lock = (key) => window.storage.setItem(key, true, { expiresIn: LIFETIME });

const triggerUnlockEvent = (eventName) => {
  const event = new Event(eventName);
  window.dispatchEvent(event);
};

const listenToUnlockEvent = (eventName, callback) => {
  window.addEventListener(eventName, callback);
};

const removeUnlockEvent = (eventName, callback) => {
  window.removeEventListener(eventName, callback);
};

const getLockSimple = (simpleKey) =>
  new Promise<void>((resolvePromise, rejectPromise) => {
    const resolve = () => {
      resolvePromise();
      removeUnlockEvent(`${simpleKey}:unlock_failure`, reject);
    };
    const reject = () => {
      rejectPromise();
      removeUnlockEvent(`${simpleKey}:unlock`, resolve);
    };

    if (isLocked(simpleKey)) {
      listenToUnlockEvent(`${simpleKey}:unlock`, resolve);
      listenToUnlockEvent(`${simpleKey}:unlock_failure`, reject);
    } else {
      resolvePromise();
    }
  });

export const lockSimple = (key, performCallback) => {
  const simpleKey = getSimpleKey(key);

  if (!isLocked(simpleKey)) {
    lock(simpleKey);

    return Promise.resolve(performCallback())
      .then(() => triggerUnlockEvent(`${simpleKey}:unlock`))
      .catch((error) => {
        triggerUnlockEvent(`${simpleKey}:unlock_failure`);
        return Promise.reject(error);
      })
      .finally(() => window.storage.removeItem(key));
  }
  return getLockSimple(simpleKey);
};
